import React, { useState } from "react";
import { DateRangePicker } from "rsuite";

const CustomeSurendra = ({ setValue, value,CampaignCreatedDate }) => {
  // console.log("CampaignCreatedDate",CampaignCreatedDate)
  const today = new Date(); // Get the current date
  const originalDate = new Date(CampaignCreatedDate!==undefined&&CampaignCreatedDate);
  originalDate.setDate(originalDate.getDate() - 3);
  const formattedDate = originalDate.toISOString().split('T')[0];
  // console.log(formattedDate); // Output: "2023-10-16"
  const endDateToDisable = new Date(formattedDate); // Replace with your desired end date
  const disabledDate = date => {
    // Disable dates in the future from today
    if (date.getTime() > today.getTime()) {
      return true;
    }
    // Disable dates in the past before a given end date
    // console.log('disabled date',endDateToDisable)
    if (date.getTime() < endDateToDisable.getTime()) {
      return true;
    }
    return false;
  };

 
  
  return (
    <div>
      <DateRangePicker
        value={value}
        disabledDate={disabledDate}
        showOneCalendar
        placeholder="Cusotm range"
        placement="bottomEnd"
        size="lg"
        ranges={[]}
        style={{border:'1px solid #1C485F',borderRadius:'6px'}}
      />
    </div>
  );
};

export default CustomeSurendra;
